import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=9ecefe7e&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"
import style0 from "./TagList.vue?vue&type=style&index=0&id=9ecefe7e&prod&lang=scss"
import style1 from "./TagList.vue?vue&type=style&index=1&id=9ecefe7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecefe7e",
  null
  
)

export default component.exports